'use strict';

exports.__esModule = true;
exports.STATUSPILL_TONES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StatusPillStyled = require('./StatusPillStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// React-Wrapper-Pflichtmuster (wie Card.jsx/Alert.jsx): reicht `className` durch,
// damit Konsumenten via styled(StatusPill) ihr Layout (margin etc.) ergaenzen koennen.
// Kapselt die runde Status-Badge-Optik (Tint-Flaeche + fuehrender Punkt) zentral.
// `tone` waehlt eine der drei Status-Farben (done/open/overdue), `children` traegt
// das Label (z.B. „Genehmigt", „Eingereicht", „Noch nicht").
var StatusPill = function StatusPill(_ref) {
  var className = _ref.className,
      tone = _ref.tone,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['className', 'tone', 'children']);

  return _react2.default.createElement(
    _StatusPillStyled.PillBox,
    _extends({ className: className, tone: tone }, rest),
    children
  );
};

StatusPill.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  tone: _propTypes2.default.oneOf(Object.values(_StatusPillStyled.STATUSPILL_TONES)),
  children: _propTypes2.default.node
} : {};

StatusPill.defaultProps = {
  className: undefined,
  tone: _StatusPillStyled.STATUSPILL_TONES.OPEN,
  children: null
};

exports.STATUSPILL_TONES = _StatusPillStyled.STATUSPILL_TONES;
exports.default = StatusPill;